<template>
  <div class="app-container">
    <AppHeader />
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <AppFooter />
    <LoginModal />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import LoginModal from '@/components/auth/LoginModal.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    LoginModal
  },
  setup() {
    const store = useStore()

    onMounted(() => {
      store.dispatch('checkAuth')
    })
  }
}
</script>

<style>
@import '@/assets/styles/main.css';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 70px; /* Header height */
}

/* Page transitions */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
